import { Card, Col, Container, Row } from 'react-bootstrap';
import './languageProficiencyPanelStyles.css';
import ProficiencyProgressBar from './proficiencyProgressBar';

const LanguageProficiencyPanel = ({ languageProficiency }) => {
  if (!languageProficiency || languageProficiency.length === 0) {
    return (
      <Card className="languageProfPanel mt-2">
        <Card.Body>
          <Container>
            <h3>Language Proficiency</h3>
            <Row>
              <Col>
                {/* <p className="no-language-message">No language proficiency available</p> */}
              </Col>
            </Row>
          </Container>
        </Card.Body>
      </Card>
    );
  }

  return (
    <Card className="languageProfPanel mt-2">
      <Card.Body>
        <Container>
          <h3>Language Proficiency</h3>
          {languageProficiency.map((language, index) => (
            <Row key={index} className="language-row mt-2">
              <Col className="language-name">{language?.language || ''}</Col>
              <Col>
                {language.proficiency ? (
                  <ProficiencyProgressBar proficiency={language.proficiency} />
                ) : null}
              </Col>
            </Row>
          ))}
        </Container>
      </Card.Body>
    </Card>
  );
};

export default LanguageProficiencyPanel;